// How a level is named to the player (docs/02-Game-Design/Glossary.md): a
// puzzle by its type, Apogee and Assemblage by themselves, and a week's
// level with XL after it (Aaron, 2026-11-01: "Assemblage XL" is a
// title, not a mode). The home card, the share caption and the Horoscope's
// picker all use these.
import type { Layer } from '../content/plan';
import type { Mode, Variant } from './schema';

export const VARIANT_NAMES: Record<Variant, string> = {
  phrase: 'Phrase',
  quotation: 'Quotation',
  category: 'Category',
  apogee: 'Apogee',
  assemblage: 'Assemblage',
};

/** The level's name on its home card: Phrase, Quotation, Category, Apogee or Assemblage. */
export function variantName(variant: Variant): string {
  return VARIANT_NAMES[variant];
}

/** The suffix a layer adds to a name: " XL" for a week's level, nothing otherwise. */
export function layerSuffix(layer: Layer = 'daily'): string {
  return layer === 'weekly' ? ' XL' : '';
}

/** The level's title on its home row: the variant's name, "Assemblage XL" or "Apogee XL" on the week. */
export function levelTitle(variant: Variant, layer: Layer = 'daily'): string {
  return VARIANT_NAMES[variant] + layerSuffix(layer);
}

/** "Quotation", "Apogee", "Apogee XL": how a play is named in shares (the same as its title, with no mode-specific case left since Timed went). */
export function playName(_mode: Mode, variant: Variant, layer: Layer = 'daily'): string {
  return levelTitle(variant, layer);
}
